// TODO: need to make these configurable, because there are two microsites
// We need to have both lists available so we can tell the user to redirect
// This might make things tricky with types, as we need to be able to configure at build time
// Maybe the types should accept all, and then we will have to filter at runtime based on the build

export const isPrimaryCampaign = import.meta.env.FOOJI_CAMPAIGN_MODE === "primary";

export const primaryCampaignCountries = ["US", "CA", "MX"];
export const receiptDataCountries = ["CA", "MX"];
export const secondaryCampaignCountries = ["GT", "CL", "DO", "SV", "HN", "NI"];
export const allSupportedCountries = [
  ...primaryCampaignCountries,
  ...secondaryCampaignCountries,
] as const;

export type SupportedCountryCode = (typeof allSupportedCountries)[number];

// FIXME: maybe we could just configure behaviour by checking the domain instead?
export const campaignCountries: SupportedCountryCode[] = isPrimaryCampaign
  ? primaryCampaignCountries
  : secondaryCampaignCountries;
// An idea is to move the lists to separate constant files, have a loader that will pick the correct list based on an env var
// Might be a nightmare to manage different vars all the time, given that the domain changes and this flag changes, so
// we should have two git branches, one that moves on top of a main one

type SupportedCountry = {
  key: SupportedCountryCode;
  defaultValue: string
};

const SUPPORTED_COUNTRIES: SupportedCountry[] = isPrimaryCampaign ? [
  { key: 'US', defaultValue: 'USA' },
  { key: 'CA', defaultValue: 'Canada' },
  { key: 'MX', defaultValue: 'Mexico' }
] : [
  { key: 'GT', defaultValue: 'Guatemala' },
  { key: 'CL', defaultValue: 'Chile' },
  { key: 'DO', defaultValue: 'República Dominicana' },
  { key: 'SV', defaultValue: 'El Salvador' },
  { key: 'HN', defaultValue: 'Honduras' },
  { key: 'NI', defaultValue: 'Nicaragua' },
];

export default SUPPORTED_COUNTRIES;

export const countryStores: Record<SupportedCountryCode, string> = isPrimaryCampaign ? {
  US: 'https://littlecaesars.com/',
  CA: 'https://littlecaesars.ca/',
  MX: 'https://mexico.littlecaesars.com/'
} : {
  GT: 'https://www.pizzapizza.com.gt/',
  CL: 'https://cl.littlecaesars.com/',
  DO: 'https://do.littlecaesars.com/',
  SV: 'https://pizzapizza.com.sv/',
  HN: 'https://littlecaesars.hn/',
  NI: 'https://ni.littlecaesars.com/',
};
